<div *ngIf="!dataStatus.empty() && !dataStatus.loading()" class="input-group mb-2">
  <div class="input-group">        
    <span class="input-group-text fa-solid fa-magnifying-glass" id="basic-addon1"></span>
    <input [(ngModel)]="searchBarContent" type="text" class="form-control" placeholder="Título do Pull Request ou nome do Webapp">        
  </div>
</div>
<div class="main-container">
  <div *ngIf="dataStatus.completed() && !dataStatus.loading()">
    <div *ngFor="let app of webAppsWithPulumi() | filterWebapps:searchBarContent" class="card d-inline-flex mb-1 me-1 webapp">
      <div class="card-body">
        <h5 class="card-title text-truncate mb-2" matTooltip="{{app.name}}">{{app.name}}</h5>
        <h6 *ngIf="app.pullRequestValid" class="card-subtitle mb-2 pr-title pr-author">{{app.pullRequestAuthor}}</h6>      
        <h6 *ngIf="!app.pullRequestValid" class="card-subtitle mb-2  pr-title pr-author">Autor não encontrado</h6>      
        <h6 *ngIf="app.pullRequestTitle && app.pullRequestValid" class="text-truncate card-subtitle mb-2  pr-title">{{app.pullRequestTitle}}</h6>
        <h6 *ngIf="!app.pullRequestValid" class="card-subtitle mb-2 pr-title-invalid">Pull Request finalizado ou não existe</h6>        
        <a [queryParams]="{ appSettingsModal: app.name }" routerLink="." class="card-link">
          <i class="fa-solid fa-screwdriver-wrench me-1"></i>
          <span>Configurar</span>
        </a>        
      </div>
    </div>  
  </div>
  <div class="w-100 h-100 d-flex justify-content-center align-items-center" *ngIf="(!dataStatus.loading() && dataStatus.empty()) || (dataStatus.loading())" >
    <app-emptysate *ngIf="!dataStatus.loading() && dataStatus.empty()">
    </app-emptysate>
    <app-progress-spinner *ngIf="dataStatus.loading()">
    </app-progress-spinner>
  </div>
</div>

<router-outlet></router-outlet>





